import { PosterDetailPage } from "@/features/poster/pages/PosterDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/poster/$id/detail")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["poster.view"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: PosterDetailPage,
});
